import MovieList from '../../components/movieList';
import Navbar from '../../components/Navbar';
import Footer from '../footer';
import '../../styles/movie.css'


const Movie= () => {

  return (
    <div className="Movie">
      <Navbar />
      <MovieList />
      <Footer />
     </div>
  );
}

export default Movie;
